/**
 * 2026-10-09 — saves a Blob as a file through a temporary object URL.
 * Shared by the CSV exports and the Voxtral transcript download.
 */
export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('download', filename);
  a.click();
  URL.revokeObjectURL(url);
}
